import './IconButton.css'

type IconButtonProps = {
  state?: boolean,
  iconStateOn?: any,
  iconStateOff?: any
  icon?: any,
  onClick: () => void, 
  height?: string
}

export default function IconButtonMR(props: IconButtonProps) {

  return (
    <button className='icon-button' onClick={ () => props.onClick()} style={{height: props.height}}>
      {props.state === undefined ? props.icon: props.icon}
      {props.state===true ? props.iconStateOn : props.iconStateOff}
    </button>
  )
}